module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/gold-small.0f92870d.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/gold-small.png
// module id = 2673
// module chunks = 11